<section class="app2 format quality p-t-5" id="contact">
  <div class="animated-bg"><i></i><i></i><i></i></div>
  <div class="container">
    <div class="row">
      @defer(on idle){
      <div class="col-sm-6 counters set-order-2">
        <div class="abouts center-text">
          <div class="w-100">
            <div class="format-head-text">
              <h3 class="about-font-header title-text m-0">{{headText}}</h3>
            </div>
            <div class="format-sub-text">
              <p class="about-para font-secondary">{{subText}}</p>
            </div>
            <form action="" id="hubspotForm">
            </form>
          </div>
        </div>
      </div>
      <div class="col-sm-6 set-height overflow-hide mb-5">
        <picture>
          <source media="(min-width: 600px)" [srcset]="functionImage?.data?.attributes?.formats?.medium?.url"
            [width]="'570px'">
          <source media="(max-width: 599px)" [srcset]="functionImage?.data?.attributes?.formats?.small?.url"
            [width]="'570px'">
          <img [src]="functionImage?.data?.attributes?.formats?.thumbnail?.url" loading="lazy" fetchpriority="high"
            [alt]="functionImage?.data?.attributes?.alternativeText" [@fadeInRight]="fadeInRight"
            class="img-fluid mobile2 img-function object-fit-cover" data-aos-duration="1500">
        </picture>
      </div>
      }@placeholder {
      @switch (screenSize$ | async) {
      @case ('xsmall') {
      <!-- Conteúdo para telas muito pequenas -->
      <div class="col-sm-4 counters set-height d-flex justify-content-center me-5">
        <ngx-skeleton-loader [theme]="{height:'26.125em', width:'18.8875em'}" />
      </div>
      <div class="col-sm-6 counters">
        <div class="abouts center-text">
          <div>
            <div class="list-about">
              <p class="mb-2 mt-3">
                <ngx-skeleton-loader count="4" [theme]="{width:'20.6875em'}" />
              </p>
            </div>
          </div>
        </div>
      </div>
      }@case ('small') {
      <!-- Conteúdo para telas pequenas -->
      <div class="col-sm-6 counters">
        <div class="abouts">
          <div>
            <div class="list-about">
              <p class="mt-5">
                <ngx-skeleton-loader count="7" [theme]="{width:'20.6875em', marginLeft:'1rem'}" />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-4 counters set-height d-flex justify-content-center ms-5">
        <ngx-skeleton-loader [theme]="{height:'26.125em', width:'18.8875em'}" />
      </div>
      }@case ('medium') {
      <!-- Conteúdo para telas Medias -->
      <div class="col-sm-6 counters">
        <div class="abouts">
          <div>
            <div class="list-about">
              <p class="mt-5">
                <ngx-skeleton-loader count="5" [theme]="{width:'23.6875em', marginLeft:'4rem'}" />
              </p>
              <p class="mt-5">
                <ngx-skeleton-loader count="5" [theme]="{width:'23.6875em', marginLeft:'4rem'}" />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-4 counters set-height d-flex justify-content-center ms-5">
        <ngx-skeleton-loader [theme]="{height:'36.125em', width:'25.8875em', marginLeft:'3rem'}" />
      </div>
      }@case ('large') {
      <!-- Conteúdo para telas grandes -->
      <div class="col-sm-6 counters">
        <div class="abouts">
          <div>
            <div class="list-about">
              <p class="mt-5">
                <ngx-skeleton-loader count="5" [theme]="{width:'27.6875em',marginLeft:'5.5rem'}" />
              </p>
              <p class="mt-5">
                <ngx-skeleton-loader count="5" [theme]="{width:'27.6875em',marginLeft:'5.5rem'}" />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-4 counters set-height d-flex justify-content-center">
        <ngx-skeleton-loader [theme]="{height:'38.125em', width:'30.8875em',  marginLeft:'5rem'}" />
      </div>
      }@default {
      <!-- Conteúdo para demais telas -->
      <div class="col-sm-6 counters">
        <div class="abouts">
          <div>
            <div class="list-about">
              <p class="mt-5">
                <ngx-skeleton-loader count="5" [theme]="{width:'27.6875em', marginLeft:'5rem'}" />
              </p>
              <p class="mt-5">
                <ngx-skeleton-loader count="5" [theme]="{width:'27.6875em', marginLeft:'5rem'}" />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-4 counters set-height d-flex justify-content-center ms-5">
        <ngx-skeleton-loader [theme]="{height:'38.125em', width:'30.8875em'}" />
      </div>
      }
      }
      }@loading {
      Loading...
      }

    </div>
  </div>
</section>